import React, { useRef, useEffect } from "react";
import * as styles from './FilterListing-tw-styles'
import Typography from "../../components/UI/Typography/Typography"
import { filtersData, filtersDataUK } from "../../constants/filterList.constants"
import { labels } from "../../constants/label.constants"
import { func, string, bool } from 'prop-types'
import './FilterListing.css'

const style = styles.defaultStyle

const FilterListing = props => {
    let filterData = {}
    const { handleSelectChange, selectedCategory, toggle, setToggle, isGeneralNews } = props
    const ref = useRef(null)
    if (isGeneralNews) {
        filterData = filtersData
    }
    else {
        filterData = filtersDataUK
    }
    function renderCategoryList() {
        return (filterData.items?.map((item) => (
            <li className={`${style?.brandFilterRow} ${selectedCategory === item.label ? 'activated' : ''}`} 
                tabIndex="0" 
                key={item?.id} 
                aria-label={`${item?.label} ${selectedCategory === item.label ? 'activated' : ''}`}
                onClick={handleSelectChange(item?.label, item?.id)}  
                role="button"
                onKeyDown={(e)=>{
                    if (e.key=="Enter") {
                        e.preventDefault()
                        handleSelectChange(item?.label, item?.id)()
                    }
                }}
            >
                <Typography className={style?.filterText} content={item?.label} />
            </li>
        ))
        )
    }
    useEffect(() => {
        const handler = event => {
            if (toggle && ref.current && !ref.current.contains(event.target)) {
                setToggle(false)
            }
        }
        document.addEventListener("mousedown", handler)
        document.addEventListener("touchstart", handler)
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handler)
            document.removeEventListener("touchstart", handler)
        }
    }, [toggle])
    return (
        <>

            <div className={style?.brandLabelWrapper}>
                <button 
                    className={toggle ? 'expandBrands brandLabel' : 'collpaseBrands brandLabel'} 
                    aria-label={
                        `${
                            toggle ? "Topics expand" : "Topics collpase"
                        }`
                    }
                    aria-expanded={toggle ? "true" : "false"}
                    role="button"
                    onClick={() => setToggle(!toggle)}
                    onKeyDown={(e)=>{
                        if (e.key === "Enter") {
                        () => setToggleValue()
                        }
                    }} 
                    ref={ref} 
                    data-testid='topics'
                >
                    <p> <span tabIndex={0}>{labels.FilterLabel} </span></p>
                </button>
            </div>

            <div className={style?.brandFilterWrapper}>
                <ul className={style?.brandFiltersList} style={{ maxHeight: toggle ? '100vh' : '0' }}>
                    {filterData.items && renderCategoryList()}
                </ul>
            </div>
        </>

    )
}

FilterListing.propTypes = {
    handleSelectChange: func,
    selectedCategory: string,
    toggle: bool,
    setToggle: func,
    isGeneralNews: bool
}

export default FilterListing;